// @ is an alias to /src
// import store from '@/store'
// import { computed } from 'vue'
import { onMounted } from 'vue';
import rightimg from '@/assets/rightimg.png';
import beian from '@/assets/beian.png';
import quan from '@/assets/icon.png';
import word from '@/assets/word.png';
export default {
  name: 'HomeView',
  components: {},

  setup() {
    // const user = computed(() => {
    //   return store.getters.getUserInfo
    // })
    onMounted(() => {});
    return {
      rightimg,
      quan,
      word,
      beian
    };
  }

};